// View events
export const VIEW_PAGE_WELCOME = 'view_page_garage_welcome';
export const VIEW_PAGE_DAMAGE_LIST = 'view_page_estimate_list_of_damage';
export const VIEW_PAGE_ORDER_TRACKING = 'view_page_order_tracking';
export const VIEW_PAGE_FAKEDOOR_LANDING = 'view_page_fake_door_landing';
export const VIEW_PAGE_CAR_DETAILS_MODAL = 'view_page_adsc_modal_car_details';
export const VIEW_PAGE_FAKEDOOR_PRICE = 'view_page_fake_door_price';
export const VIEW_PAGE_SLOTS = 'view_page_adsc_view_slots';
export const VIEW_PAGE_LOCATION_DETAILS = 'view_page_adsc_location_capture';
export const VIEW_PAGE_ADDRESS_CAPTURE = 'view_page_adsc_address_capture';
export const VIEW_PAGE_CONFIRMATION = 'view_page_adsc_booking_confirmation';

export const VIEW_PAGE_ENTER_CAR_NUMBER = 'view_page_adsc_modal_enter_car_reg';
export const VIEW_PAGE_ENTER_MANUAL_CAR_DETAILS =
    'view_page_adsc_manual_car_details';
export const VIEW_PAGE_LANDING_LOCATION_ACCESS =
    'view_page_landing_location_access';
export const VIEW_PAGE_LANDING_LOCATION_DENIED =
    'view_page_landing_location_denied';
export const VIEW_PAGE_LOCATION_NOT_SERVICEABLE =
    'view_page_location_not_serviceable';
export const VIEW_PAGE_LOCATION_ACCESS_ASKED =
    'view_page_location_access_asked';
export const VIEW_PAGE_LOCATION_ACCESS_GRANTED =
    'view_page_landing_location_access_granted';
export const VIEW_PAGE_LOCATION_ACCESS_DENIED_REFRESHED_CLICK =
    'view_page_landing_location_access_granted_refresh_clicked';
export const VIEW_PAGE_ADSC_CITY_SELECTION = 'view_page_adsc_city_selection ';
export const VIEW_PAGE_PAYMENT_PENDING = 'view_page_payment_pending';
export const VIEW_PAGE_PICK_DROP = 'view_page_pick_drop';
export const VIEW_PAGE_SERVICE_CENTRE_NEAR_YOU =
    'view_page_service_centre_near_you';
export const VIEW_PAGE_FAKEDOOR_LANDING_STATUS_CARD =
    'view_page_fake_door_landing_status_card';
export const VIEW_PAGE_REPEAT_DETAILS_CONFIRMATION =
    'view_page_repeat_details_confirmation';
export const VIEW_PAGE_ADSC_VIDEO_LANDING_PAGE =
    'view_page_adsc_video_landing_page';
export const VIEW_PAGE_ADSC_OFFER_CLAIM_SUCCESS =
    'view_page_adsc_offer_claim_success';

// Track events
export const TAP_OPEN_BREAKUP = 'tap_open_price_breakup';
export const TAP_OPEN_DAMAGE_LIST = 'tap_open_damage_details';
export const TAP_HELP_CTA = 'tap_help_cta';
export const TAP_BTN_APPROVE = 'tap_btn_estimate_approve';
export const TAP_BTN_NEXT = 'tap_btn_estimate_next';
export const TAP_QA_PHOTO = 'tap_repair_photo_qc';
export const TAP_HB_PHOTO = 'tap_repair_photo_heartbeat';
export const TAP_LOOKS_GOOD = 'tap_btn_adsc_looks_good';
export const TAP_BTN_CHECK_PRICE = 'tap_btn_adsc_check_price';
export const TAP_BTN_BOOK_SLOT = 'tap_btn_adsc_book_slot';
export const TAP_BTN_SLOT_CONFIRM = 'tap_btn_adsc_proceed_slot';
export const TAP_BTN_ADDRESS_CONFIRMATION = 'tap_btn_adsc_schedule_pickup';
export const TAP_BTN_SUBMIT_MANUAL_CAR_DETAILS =
    'tap_btn_submit_manual_car_details';
export const TAB_BTN_SUBMIT_CAR_REG_NUMBER = 'tap_btn_adsc_submit_reg_number';
export const TAP_BTN_NOT_THIS_CAR = 'tap_btn_adsc_not_this_car';
export const TAP_BTN_GET_NOTIFIED =
    'tap_btn_location_not_serviceable_get_notified';
export const TAP_BTN_CITY_SELECTED = 'tap_btn_city_selected';
export const TAP_BTN_RESUME_BOOKING_MODAL = 'tap_btn_resume_booking_modal';
export const TAP_BTN_REPEAT_SELECT_SLOT = 'tap_btn_repeat_select_slot';
export const TAP_BTN_REPEAT_CHECK_PRICE = 'tap_btn_repeat_check_price';
export const TAP_BTN_REPEAT_EDIT_ADDRESS = 'tap_btn_repeat_edit_address';
export const TAP_BTN_ADSC_REMINDER_OPT_OUT = 'tap_btn_adsc_reminder_opt_out';
export const TAP_BTN_HOME = 'tap_btn_home';
export const TAP_BTN_BUY_CAR = 'tap_btn_buy_car';
export const TAP_BTN_SERVICE_CAR = 'tap_btn_service_car';
export const TAP_BTN_SELL_CAR = 'tap_btn_sell_car';
export const TAP_BTN_ARTICLES = 'tap_btn_news';
export const TAP_BTN_RESERVE_SLOT = 'tap_btn_reserve_slot';
export const TAP_BTN_ADSC_VIDEO_CROSS = 'tap_btn_adsc_video_cross';

//online booking flow

// view events
export const VIEW_PAGE_ADSC_ENTER_PINCODE = 'view_page_adsc_enter_pincode';
export const VIEW_PAGE_CATEGORY_SELECTION = 'view_page_category_selection';
export const VIEW_PAGE_PERIODIC_SERVICE_LANDING =
    'view_page_periodic_service_landing';
export const VIEW_PAGE_PMS_PRICE = 'view_page_pms_price';
export const VIEW_PAGE_SCHEDULE_PICKUP = 'view_page_schedule_pickup';
export const VIEW_PAGE_SCHEDULE_DROP = 'view_page_schedule_drop';
export const VIEW_PAGE_MODAL_SELF_DROP = 'view_page_modal_self_drop';
export const VIEW_PAGE_ADSC_SELF_DROP_NO_SLOT_CONFIRMATION =
    'view_page_adsc_self_drop_no_slot_confirmation';
export const VIEW_PAGE_ADSC_PMS_PAYMENT_CONFIRMATION =
    'view_page_adsc_pms_payment_confirmation';
export const VIEW_PAGE_SPECIFIC_SERVICE_LANDING =
    'view_page_specific_service_landing';
export const VIEW_PAGE_NOT_SURE_ABOUT_ISSUE_LANDING =
    'view_page_not_sure_about_issue_landing';
export const VIEW_PAGE_ADSC_CAR_SPA = 'view_page_adsc_car_spa';
export const VIEW_PAGE_CALLBACK_SCHEDULED = 'view_page_callback_scheduled';
export const VIEW_PAGE_CALL_BACK_FAQ = 'view_page_call_back_faq';
export const VIEW_PAGE_ADSC_HELP_CALL = 'view_page_adsc_help_call';
export const VIEW_PAGE_ADSC_MODIFY_BOOKING_MODAL =
    'view_page_adsc_modify_booking_modal';
export const VIEW_PAGE_CANCEL_BOOKING_MODAL = 'view_page_cancel_booking_modal';
export const VIEW_PAGE_MMV_NOT_SERVICEABLE = 'view_page_mmv_not_serviceable';
export const VIEW_PAGE_LOCATION_ACCESS_DENIED =
    'view_page_location_access_denied';
export const VIEW_PAGE_WATCH_GARAGE_VIDEO = 'view_page_watch_garage_video';
export const VIEW_PAGE_MODAL_PINCODE_NOT_SERVICEABLE =
    'view_page_modal_pincode_not_serviceable';

// track events
export const TAP_BTN_PINCODE_CONFIRM = 'tap_btn_pincode_confirm';
export const TAP_BTN_EXPLORE_OFFERING = 'tap_btn_explore_offering';
export const TAP_BTN_CATEGORY_SELECTED = 'tap_btn_category_selected';
export const TAP_BTN_PMS_CHECK_PACKAGE_PRICE =
    'tap_btn_pms_check_package_price';
export const TAP_BTN_PMS_BROWSE_SERVICES = 'tap_btn_pms_browse_services';
export const TAP_BTN_PMS_PROCEED_TO_BOOK = 'tap_btn_pms_proceed_to_book';
export const TAP_BTN_ADD_CAR_MANUALLY = 'tap_btn_add_car_manually';
export const TAP_BTN_SUBMIT_CAR_REG_NUMBER = 'tap_btn_submit_car_reg_number';
export const TAP_BTN_ADSC_SUBMIT_CAR_DETAILS_MANUALLY =
    'tap_btn_adsc_submit_car_details_manually';
export const TAP_BTN_PMS_LOOKS_GOOD = 'tap_btn_pms_looks_good';
export const TAP_BTN_BOOK_PICKUP = 'tap_btn_book_pickup';
export const TAP_BTN_DROP_CAR = 'tap_btn_drop_car';
export const TAP_BTN_DROP_CAR_SLOT_RESERVE = 'tap_btn_drop_car_slot_reserve';
export const TAP_BTN_DROP_CAR_NO_SLOT_RESERVE =
    'tap_btn_drop_car_no_slot_reserve';
export const TAP_BTN_DROP_CAR_NO_SLOT_RESERVE_CONFIRMATION =
    'tap_btn_drop_car_no_slot_reserve_confirmation';
export const TAP_BTN_GARAGE_DETAILS = 'tap_btn_garage_details';
export const TAP_BTN_ADSC_CHOOSE_SLOT = 'tap_btn_adsc_choose_slot';
export const TAP_BTN_DOWNLOAD_APP = 'tap_btn_download_app';
export const TAP_BTN_CHECKOUT_PRICES = 'tap_btn_checkout_prices';
export const TAP_BTN_TALK_TO_EXPERT = 'tap_btn_talk_to_expert';
export const TAP_BTN_ANSWER_QUESTION = 'tap_btn_answer_question';
export const TAP_BTN_SUBMIT_CALL_BACK_FAQ = 'tap_btn_submit_call_back_faq';
export const TAP_BTN_GET_CAR_TO_GARAGE = 'tap_btn_get_car_to_garage';
export const TAP_BTN_ADSC_HELP = 'tap_btn_adsc_help';
export const TAP_BTN_MODIFY_BOOKING = 'tap_btn_modify_booking';
export const TAP_BTN_MODIFY_BOOKING_RESCHEDULE =
    'tap_btn_modify_booking_reschedule';
export const TAP_BTN_MODIFY_BOOKING_CANCEL = 'tap_btn_modify_booking_cancel';
export const TAP_BTN_CANCEL_SLOT_CONFIRMATION =
    'tap_btn_cancel_slot_confirmation';
export const TAP_BTN_ASSET_ICON = 'tap_btn_asset_icon';
export const TAP_BTN_SCHEDULE_CALLBACK = 'tap_btn_schedule_callback';
export const TAP_BTN_ADSC_CALL_NOW = 'tap_btn_adsc_call_now';
export const TAP_BTN_SPECIFIC_PROCEED_TO_SCHEDULE =
    'tap_btn_specific_proceed_to_schedule';
export const TAP_BTN_GET_DIRECTION = 'tap_btn_get_direction';

export const TAP_BTN_MODAL_SELECT_OTHER_LOCATION =
    'tap_btn_modal_select_other_location';
export const TAP_BTN_MODAL_SPEAK_TO_AGENT = 'tap_btn_modal_speak_to_agent';
export const TAP_BTN_PICK_AND_DROP_NOTIFY_ME =
    'tap_btn_pick_and_drop_notify_me';
export const TAP_BTN_FIND_SERVICE_CENTRE_NEAR_YOU =
    'tap_btn_find_service_centre_near_you';
export const TAP_BTN_PINCODE_CONFIRM_PICK_DROP =
    'tap_btn_pincode_confirm_pick_drop';
export const TAP_BTN_BOOK_FREE_PICKUP = 'tap_btn_book_free_pickup';
export const TAP_BTN_ADSC_CLAIM_OFFER = 'tap_btn_adsc_claim_offer';

//QR code events
export const VIEW_PAGE_OFFER = 'view_page_adsc_offer_page';
export const TAP_BTN_CHECK_OFFER_ELIGIBILITY =
    'tap_btn_check_offer_eligibility';
export const VIEW_PAGE_OFFER_CHECK = 'view_page_adsc_offer_check_page';

// SEO events
export const TAP_BTN_BRAND_SELECTED = 'tap_btn_brand_selected';
export const TAP_BTN_SERVICE_CENTRE_SELECTED =
    'tap_btn_service_centre_selected';
export const TAP_BTN_SERVICE_CENTRE_LOCATION =
    'tap_btn_service_centre_location';

export const TAP_BTN_VIDEO_INTERACTION = 'tap_btn_video_interaction';
export const TAP_BTN_FAQ = 'tap_btn_faq';
